import {Router} from '@angular/router';
import moment from 'moment';
import {TranslateService} from '@ngx-translate/core';
import {Component, OnInit, ViewChild} from '@angular/core';
import {NotificationsModel} from 'src/app/models/notifications.model';
import {NotificationService} from 'src/app/services/notification.service';
import {PaginatedResponse} from 'src/app/models/paginated-response.model';
import {ErrorHandlerService} from 'src/app/services/error-handler.service';
import {
  PopoverController,
  LoadingController,
  IonInfiniteScroll,
  ActionSheetController,
  AlertController
} from '@ionic/angular';
import {marker} from '@biesbjerg/ngx-translate-extract-marker';

@Component({
  selector: 'shc-notifications',
  templateUrl: './notifications.page.html',
  styleUrls: ['./notifications.page.scss'],
})
export class NotificationsPage implements OnInit {

  page: number;
  loading: boolean;
  loadingMoreData = false;
  notifications: PaginatedResponse<NotificationsModel>;
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;

  constructor(
    public popoverController: PopoverController,
    private notificationService: NotificationService,
    private loadingCtrl: LoadingController,
    private translate: TranslateService,
    private actionSheetController: ActionSheetController,
    private errorService: ErrorHandlerService,
    private router: Router,
    private alertController: AlertController
  ) {
  }

  ngOnInit() {
  }

  ionViewWillEnter() {
    this.page = 1;
    this.getNotifications('');
  }

  async navigateTo(notification: NotificationsModel) {
    // if(!notification?.data?.body.includes('offer')
    //   && !notification?.data?.body.includes('New Item:')
    //   && !notification?.data?.body.includes('Offer')) {
    //     // return;
    //     this.markAsRead(notification?.id);

    //   this.router.navigate([
    //     'tabs/chat'
    //   ])
    //   return;
    // }

    if (notification?.product?.chat_id) {
      this.markAsRead(notification?.id);

      this.router.navigate(['chat', notification?.product?.chat_id]);
      //  this.router.navigate(['chat', notification?.product?.chat_id],{
      //   state: {
      //     fromNotification: true,
      //     role: 'seller', // You can use this to differentiate between buyer/seller
      //     product: notification.product
      //   }
      // });
      return;
    }

    if (notification?.product) {
      this.markAsRead(notification?.id);

      this.router.navigate([
        'wardrobe/detail/' + notification?.product?.id
      ]);
    }

    if (notification?.type === 'App\\Notifications\\NewFollowerNotification' && notification?.data?.model_id) {
      this.markAsRead(notification?.id);
      this.router.navigate(['user', notification.data.model_id]);
      return;
    }

    if (!notification?.product && notification?.data?.title && notification?.data?.description) {
      this.markAsRead(notification?.id);
      const alert = await this.alertController.create({
        header: notification.data.title,
        message: notification.data.description,
        buttons: ['OK'],
        mode: 'md'
      });
      await alert.present();
    }

  }

  showNotificationText(notification: NotificationsModel) {
    const type = notification?.type;

    if (type?.includes('CustomPushNotification')
      || type?.includes('RefundPaymentNotification')
      || type?.includes('RefundPaymentFailedNotification')) {
      // Deze typen dragen hun eigen, al-vertaalde title/body of title/description
      // aan vanuit de backend (title al door __() gehaald via NotificationResource).
      return notification?.data?.title;
    } else if (notification?.data?.body === 'offer') {
      return this.translate.instant('Notifications.Offer');
    } else if (notification?.data?.body?.includes("New Item:")) {
      return this.translate.instant('Notifications.NewItem', {
        userName: notification?.product?.user?.username ? notification?.product?.user?.username : notification?.product?.user?.name,
        itemName: notification?.product?.title
      });
    } else if (notification?.data?.body === 'Offer Accepted') {
      return this.translate.instant('Notifications.OfferAccepted', {
        itemName: notification?.product?.title
      });
    } else if (notification?.data?.body === 'Offer Rejected') {
      return this.translate.instant('Notifications.OfferRejected', {
        itemName: notification?.product?.title
      });
    }

    return notification?.data?.body;
  }

  getNotifications(event?: any): void {
    this.loading = true;
    this.loadingCtrl.create({
      message: this.translate.instant(marker('Loading'))
    }).then(loadingEl => {
      if (!this.loadingMoreData) {
        // this.showLoader();
        loadingEl.present();
      }
      this.notificationService.getNotifications({page: this.page}).subscribe(
        res => {
          console.log(res);
          this.loading = false;
          loadingEl.dismiss();
          if (this.notifications && this.notifications.meta) {
            if (this.page === 1) {
              this.notifications = res;
            } else {
              this.notifications.meta = res.meta;
              this.notifications.data = [...this.notifications.data, ...res.data];
            }
          } else {
            this.notifications = res;
          }
          if (event) {
            event.target.complete();
          }
          this.page++;
        },
        error => {
          loadingEl.dismiss();
          this.errorService.handle(error);
        }
      );
    });
  }

  getTimeFromNow(date) {
    return moment(date).fromNow();
  }

  routeToNotification(notification: NotificationsModel) {
    if (!notification.is_read) {
      this.notificationService.markAsRead(notification.id).subscribe(
        res => {
          console.log(res);
        },
        error => {
          this.errorService.handle(error);
        }
      );
    }
  }

  async presentActionSheet(id: number) {
    const actionSheet = await this.actionSheetController.create({
      mode: 'md',
      cssClass: 'notification-action-sheet',
      buttons: [
        {
          text: this.translate.instant(marker('Notifications.Remove')),
          cssClass: '',
          icon: '../../../assets/icons/remove.svg',
          handler: () => {
            this.removeNotification(id);
          }
        }, {
          text: this.translate.instant(marker('Notifications.MarkAsRead')),
          cssClass: '',
          icon: '../../../assets/icons/reading-book.svg',
          handler: () => {
            this.markAsRead(id);
          }
        }
      ]
    });
    await actionSheet.present();
  }

  markAsRead(id: number) {
    this.notificationService.markAsRead(id).subscribe(
      res => {
        const index = this.notifications.data.findIndex(n => n.id === id);
        this.notifications.data[index].is_read = true;
      },
      error => {
        this.errorService.handle(error);
      }
    );
  }

  removeNotification(id: number) {
    this.notificationService.destroyNotification(id).subscribe(
      res => {
        this.notifications.data = this.notifications.data.filter(n => n.id !== id);
      },
      error => {
        this.errorService.handle(error);
      }
    );
  }

  loadData(event): void {
    if (this.notifications.meta.current_page < this.notifications.meta.last_page) {
      this.loadingMoreData = true;
      this.getNotifications(event);
    } else {
      this.infiniteScroll.disabled = true;
    }
  }

}
